import { Component, OnInit } from '@angular/core';
import { LayoutEditorService } from '../../layout-editor.service';

@Component({
  selector: 'ngx-pallette',
  templateUrl: './pallette.component.html',
  styleUrls: ['./pallette.component.scss']
})
export class PalletteComponent implements OnInit {
  title:string = "Pallette";
  toolTip:string = "Color range used for general elements such as backgrounds, buttons and text.You can override this for specific elements.";
  themes = [
    {
      id:1,
      value: 'default',
      name: 'Default',
      pallette:'#3366ff',
    },
    {
      id:2,
      value: 'green-house',
      name: 'Green House',
      pallette:"#8CA52E"
    },
    {
      id:3,
      value: 'navy-kadet',
      name: 'Navy Kadet',
      pallette:"#192A53"
    },
    {
      id:4,
      value: 'earthtone',
      name: 'Earth Tone',
      pallette:"#B73225"
    },
    {
      id:5,
      value: 'makeup',
      name: 'Makeup',
      pallette:"#DDAF94"
    },
    {
      id:6,
      value: 'blackish',
      name: 'Blackish',
      pallette:"#202020"
    },
    {
      id:7,
      value: 'cactus',
      name: 'Cactus',
      pallette:"#74AC67"
    },
    {
      id:8,
      value: 'olive-tree',
      name: 'Olive Tree',
      pallette:"#77A19B"
    },
    {
      id:9,
      value: 'citric-acid',
      name: 'Citric Acid',
      pallette:"#FE7C02"
    },
    {
      id:10,
      value: 'wind-swept',
      name: 'Wind Swept',
      pallette:"#AB9390"
    },
    {
      id:11,
      value: 'fools-gold',
      name: 'Fools Gold',
      pallette:"#FFC507"
    },
    {
      id:12,
      value: 'skyroof',
      name: 'Skyroof',
      pallette:"#87CEEB"
    },
    {
      id:13,
      value: 'riding-hood',
      name: 'Ridinghood',
      pallette:"#FF0000"
    }
  ];
  constructor(private layoutEditorService:LayoutEditorService) { }

  ngOnInit(): void {
  }
  setTheme(theme:any){
    console.log(theme);
    this.layoutEditorService.setPallette(theme.value)
  }

}
